import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { CustomCapabilityConfigurationForm } from '../../../../../core/forms';
import { MatInputModule } from '@angular/material/input';

export const RECORD_AND_TRANSCRIBE_GOAL_ID = 'recordAndTranscribe';

@Component({
  selector: 'ai-record-and-transcribe-capability-form',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, GalaxyFormFieldModule, MatInputModule],
  templateUrl: './record-and-transcribe-capability-form.component.html',
})
export class RecordAndTranscribeCapabilityFormComponent extends CustomCapabilityConfigurationForm {}
